import { render, staticRenderFns } from "./VaimoTooltip.vue?vue&type=template&id=6e2871e9&scoped=true&"
import script from "./VaimoTooltip.vue?vue&type=script&lang=ts&"
export * from "./VaimoTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoTooltip.vue?vue&type=style&index=0&id=6e2871e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2871e9",
  null
  
)

export default component.exports